export const config = {
  AUTH_GW_BASE_URL: process.env.REACT_APP_AUTH_BASE_URL || "null-ref",
  I18N_SYSTEM: process.env.REACT_APP_I18N_SYSTEM || "",
  SID_GW_BASE_URL: process.env.REACT_APP_SID_GW_BASE_URL || "null-ref",
  TRANSLATIONS_API_BASE_URL:
    process.env.REACT_APP_TRANSLATIONS_API_BASE_URL || "null-ref",
  TRANSACTION_I18N_PLATFORM_SYSTEM:
    process.env.REACT_APP_TRANSACTION_I18N_PLATFORM_SYSTEM ||
    "transaction-investor-platform",
  TRANSACTION_I18N_NORMALIZER_SYSTEM:
    process.env.REACT_APP_TRANSACTION_I18N_NORMALIZER_SYSTEM ||
    "transaction-normalizer",
  SID_ASSET_DETAILS_GW_BASE_URL:
    process.env.REACT_APP_SID_ASSET_DETAILS_GW_BASE_URL || "",
  TAX_CENTER_GW_BASE_URL: process.env.REACT_APP_TAX_CENTER_GW_BASE_URL || "",
  BC_INVESTOR_FE_ENTRY_POINT_URL:
    process.env.REACT_APP_BC_INVESTOR_FE_ENTRY_POINT_URL || "null-ref",
  SID_FE_ENTRY_POINT_URL:
    process.env.REACT_APP_SID_FE_ENTRY_POINT_URL || "null-ref",
  FEATURE_FLAGS: {},
} as const;
